import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initializeEnvironmentValidation } from './utils/envValidator';
import sessionManager from './utils/sessionManager';
import securityLogger from './utils/securityLogger';

// Initialize security systems before app startup
try {
  // Validate environment security
  initializeEnvironmentValidation();
  
  // Initialize session management
  window.sessionManager = sessionManager;
  securityLogger.logSession('system_startup', {
    environment: process.env.NODE_ENV,
    timestamp: Date.now()
  });
  
  console.log('✅ Security systems initialized successfully');
} catch (error) {
  securityLogger.logSecurityViolation('startup_failure', {
    error: error.message,
    severity: 'critical'
  });
  
  console.error('🚨 App startup blocked due to critical security issues:', error.message);
  if (process.env.NODE_ENV === 'production') {
    // In production, show error page instead of starting app with security issues
    document.body.innerHTML = `
      <div style="padding: 20px; background: #ff4444; color: white; text-align: center; font-family: Arial;">
        <h1>🚨 Security Configuration Error</h1>
        <p>The application cannot start due to critical security configuration issues.</p>
        <p>Please contact the administrator.</p>
      </div>
    `;
    throw error;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
